import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { calculateListPosition } from './menu-list.helpers';
import classNames from 'classnames';
import styles from './menu-list.module.css';
export function MenuList(props) {
    var _a;
    var _b, _c;
    var _d = props.index, index = _d === void 0 ? 0 : _d, _e = props.zIndex, zIndex = _e === void 0 ? 25 : _e;
    var _f = useState(), buttonElement = _f[0], setButtonElement = _f[1];
    var listRef = useRef(null);
    var _g = useState(window.innerWidth < 600), isMobile = _g[0], setIsMobile = _g[1];
    var _h = useState(false), isOpen = _h[0], setIsOpen = _h[1];
    var _j = useState(), yQuadrant = _j[0], setYQuadrant = _j[1];
    useEffect(function () {
        var handleResize = function () {
            setIsMobile(window.innerWidth < 600);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    useEffect(function () {
        if (!isOpen)
            return;
        var list = listRef.current;
        if (!!list) {
            handleScroll();
            window.addEventListener('scroll', handleScroll);
            window.requestIdleCallback(function () { return window.addEventListener('click', onClickWindowHandler); });
        }
    }, [isOpen, props.items]);
    function openMenu() {
        setIsOpen(true);
    }
    function closeMenu(event, item) {
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        closeMenuAction();
        if (!item || item.disabled)
            return;
        item.onClick(props.data);
        if (props.onSelect)
            props.onSelect(item.text);
    }
    function closeMenuAction() {
        var list = listRef.current;
        if (!!list)
            list.classList.add('remove');
        setIsOpen(false);
        window.removeEventListener('scroll', handleScroll);
        // Also part of the hack to get this component
        // to work within clickable items without propagating
        // and bubbling events
        window.onmenuclose = void 0;
    }
    var setButtonRef = function (node) {
        setButtonElement(node);
    };
    function onClickWindowHandler(event) {
        var _a;
        if (!isOpen)
            return;
        if (!((_a = listRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
            closeMenuAction();
        }
    }
    function handleScroll() {
        var button = buttonElement;
        var list = listRef.current;
        if (!!button && !!list) {
            setYQuadrant(calculateListPosition(button, list));
        }
    }
    useEffect(function () {
        return function () {
            window.removeEventListener('click', onClickWindowHandler);
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isOpen]);
    return (React.createElement(React.Fragment, null,
        props.children({ openMenu: openMenu, setButtonRef: setButtonRef, isOpen: isOpen, yQuadrant: yQuadrant, closeMenu: closeMenu }),
        isOpen &&
            ReactDOM.createPortal(React.createElement(React.Fragment, null,
                isMobile && React.createElement("div", { className: classNames(styles.menuMobileOverlay) }),
                React.createElement("ul", { ref: listRef, className: classNames(styles.menuList, (_a = {}, _a[styles.active] = isOpen, _a), "kplr_menuList"), style: {
                        zIndex: 1 * index + zIndex,
                        width: !!props.dropdown && !!((_b = buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.width) ? "".concat((_c = buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.getBoundingClientRect()) === null || _c === void 0 ? void 0 : _c.width, "px") : 'fit-content',
                        border: !!props.large ? 'transparent' : '1px solid var(--borders)',
                    } }, props.items.map(function (item, index) {
                    var _a;
                    return (React.createElement("li", { key: item.text + index, className: classNames(styles.menuListItem, (_a = {}, _a[styles.disabled] = item.disabled, _a[styles.active] = item.active, _a)), onClick: function (event) { return closeMenu(event, item); } }, item.text));
                }))), window.document.body)));
}
export default MenuList;
